export const DEFAULT_FILE = 'example.mid';
export const MIDI_A0 = 22;
export const SUBBEATS = 4;
export const BEATS = 4;
export const BARS = 8;
export const VALID_EXTENSIONS = ['mid', 'midi'];
// upper and lower limits for remapping velocity
export const STRETCH_UPPER = 105 / 127
export const STRETCH_LOWER = 10 / 127